import { Box, Text, Popover, PopoverTrigger, PopoverContent, cssVar } from '@cad-arc';
import { FlagRenderer } from '../common/components/flag-renderer/flag-renderer';

const DATA_ITEM_LINE_HEIGHT = '16.8px';

export const NarrativePopover = ({
    narrative,
    style,
}: {
    narrative: string;
    style?: React.CSSProperties;
}) => (
    <Popover>
        <PopoverTrigger asChild>
            <Text
                data-testid="NARRATIVE_POPOVER_TRIGGER"
                as="span"
                variant="bodyMd"
                fontWeight="bold"
                style={{
                    color: cssVar('arc.colors.brand.default'),
                    cursor: 'pointer',
                    lineHeight: DATA_ITEM_LINE_HEIGHT,
                    ...(style ? style : {}),
                }}
            >
                Narrative
            </Text>
        </PopoverTrigger>
        <PopoverContent>
            <Text variant="headingXs">Narrative</Text>
            <Box fontSize="sm" marginTop="2" maxWidth={268} data-testid="NARRATIVE_POPOVER_CONTENT">
                <FlagRenderer text={narrative} />
            </Box>
        </PopoverContent>
    </Popover>
);
